<template>
  <b-form @submit="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>Configurar Relatório de Oportunidades</b>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos">Salvar</b-button>

            <router-link
              :to="$routeBack('relatorios_list')"
              class="btn btn-outline-muted mr-2"
            >
              Voltar para Listagem
            </router-link>
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Configurar Arquivo
          </template>
          <TableConfig
            ref="dados_basicos"
            v-model="relatorio_oportunidades.cabecalho"
          />
        </b-tab>

        <b-tab>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Filtrar Oportunidades
          </template>
          <DadosBasicos ref="dados_basicos" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import DadosBasicos from "./FormOportunidades/DadosBasicos.vue";
import TableConfig from "./FormOportunidades/TableConfig.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: { DadosBasicos, TableConfig },
  data: () => ({
    validations: {
      dados_basicos: true,
    },
  }),
  computed: {
    ...mapState("relatorios", ["relatorio_oportunidades"]),
  },
  methods: {
    ...mapActions("relatorios", [
      "ActionSaveRelatorioOportunidades",
      "ActionNewRelatorio",
    ]),
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          await this.ActionSaveRelatorioOportunidades(
            this.relatorio_oportunidades
          );
          //this.$emit("saved", this.relatorio.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          console.log("error", error);
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      return true;
    },
  },
  async created() {
    this.ActionNewRelatorio();
  },
};
</script>

<style></style>
